import React from "react";
import Image from "next/image";
import { Hourglass, Phone } from "lucide-react"
import HooverInformation from "./HooverInformation";

const TaxiBox = ({
  taxiData,
  telephone
}: {
  taxiData: any;
  telephone: string;
  course_token: string;
}) => {
  
  return (
    <div className="flex flex-col">
      {(taxiData?.user_token ? (
      <>
        <div className="flex gap-3">
        {taxiData.user_pic && 
          <div className="flex flex-col">
            <Image
              src={`${process.env.NEXT_PUBLIC_ASSETS_HOST}${taxiData.user_pic}`}
              alt="Taxi icon"
              width={100}
              height={100}
              className="rounded-lg h-20 w-20"
            />
          </div>}
          {taxiData.vehicule_pic && 
          <div className="flex flex-col">
            <Image
              src={`${process.env.NEXT_PUBLIC_ASSETS_HOST}${taxiData.vehicule_pic}`}
              alt="Taxi icon"
              width={100}
              height={100}
              className="rounded-lg h-20 w-20"
            />
          </div>}
          
        </div>
        <div>
          <div className="flex items-center mt-1">
            {!!taxiData.pre_allocated && <HooverInformation label={"Ce chauffeur est préalloué. Le numéro de téléphone pour le contacter apparaitra 15 minutes avant le début de la réservation"}>
            <Hourglass className="h-4 w-4 opacity-70" />
                </HooverInformation>}
                <div className="flex">
                <p> {taxiData.nickname}&nbsp;</p>
                <p>{!!taxiData.immatriculation && `(${taxiData.immatriculation})` }</p>
                </div>
          </div>{!taxiData.pre_allocated && 
          <div className="flex items-center gap-2">
            <Phone className="h-3 w-3 fill-white text-current" /><p> {telephone}</p>
          </div>}
        </div>
      </>):(<div></div>))}
      
    </div>
  );
};

// user_pic: '/media/upload_pictures/user_WNjSqCzW7w.jpg',
// vehicule_pic: '/media/upload_pictures/user_6szpx2C_hyLbQ2vxEtfzCkD.jpg',
// brand: ' Toyota ',
// immatriculation: 'AC217TT',
// nickname: 'Brahim'

export default TaxiBox;
